<template>
  <SpectreToastGroup :toasts="queue" />
  <div class="sticky top-0 z-50 min-h-16 lg:min-h-0">
    <SpectreNavigation
      ref="navElement"
      :links="page.props.navigation"
      product="property_reports"
      :user="{ name: page.props.auth.user?.name ?? '', roles: page.props.auth.user?.roles ?? [] }"
      :environment="page.props.app.env"
      @request-access="handleRequestAccess"
    />
  </div>
  <slot />
</template>

<script setup lang="ts">
import type {
  ComponentPublicInstance } from 'vue';
import {
  nextTick,
  onMounted,
  ref,
} from 'vue';
import { requestProductAccess as internalApiRequestProductAccess } from '@/routes/internal-api';
import { usePage } from '@inertiajs/vue3';
import axios from 'axios';
import {
  SpectreNavigation, SpectreToastGroup,
} from '@agentsoftware/spectre-ui';
import useToastQueue from '@/Stores/ToastQueue';
import { trackUser } from '@/Support/MixpanelTracking';
import { whenever } from '@vueuse/core';
import { useNavigationBarStore } from '@/Stores/NavigationBar';

const page = usePage();

const { enqueue, queue } = useToastQueue();

whenever(() => page.props.flash.toasts, (newValue) => {
  newValue.forEach((toast) => {
    enqueue(toast.label, toast.description, toast.type);
  });
});

const handleRequestAccess = (product: string) => {
  axios.post(internalApiRequestProductAccess.url(), { product });
};

if (page.props.auth.user?.id) {
  trackUser(
    page.props.auth.user.id,
    {
      $email: page.props.auth.user.email,
      $name: page.props.auth.user.name,
    },
  );
}

const navElement = ref<ComponentPublicInstance>();
const navigationBarStore = useNavigationBarStore();

onMounted(() => {
  nextTick(() => {
    if (navElement.value) {
      navigationBarStore.setNavBarHeight(navElement.value?.$el.offsetHeight);
    }
  });
});
</script>

<style>
.mapboxgl-marker {
  outline: none;
}
</style>
